module.exports = __webpack_public_path__ + "static/media/sukkot.0a5181d7.svg";